module.exports = __webpack_public_path__ + "img/Rules_02.df1ecbb5.png";